import React, { Component } from "react"
import "./Legal.scss"
import { withRouter } from "react-router-dom"
import { withApollo } from "react-apollo"
import gql from "graphql-tag"

export const GET_LEGAL_GQL = gql`
  query {
    legal {
      content
    }
  }
`

class Legal extends Component {
  state = {
    loading: true,
    content: "",
  }

  componentDidMount() {
    this.loadContent()
  }

  loadContent() {
    this.props.client
      .query({
        query: GET_LEGAL_GQL,
      })
      .then(({ data }) => {
        if (data) {
          this.setState({ loading: false, content: data.legal.content })
        }
      })
  }

  renderError() {
    return <p>Error!!! Can't load content. Please contact our admin for more details.</p>
  }

  render() {
    return (
      <div className="Legal">
        <h2>Legal</h2>
        {this.state.loading ? (
          <div className="text-center">
            <h2>Loading...</h2>
            <br />
            <br />
          </div>
        ) : (
          <div dangerouslySetInnerHTML={{ __html: this.state.content }}></div>
        )}
      </div>
    )
  }
}

export default withRouter(withApollo(Legal))
